/**
 * Doctors store.
 *
 */

import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { Doctors } from '@/models/doctors';
import filterModel from '@/store/doctors/filterModel';
import DoctorsFilter from '@/store/doctors/filterEntity';
import { Filter } from '@/types/filter/filter';
import { TableApiInterface } from '@/types/page/table';
import { formatPhone } from '@/lib/Utils';
import { truncateString } from '@/lib/truncate';

export const MODULE_NAME = Doctors.moduleName;

enum doctorDegreeEnum {
    YES = 'Да',
    NO = 'Нет',
}

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class DoctorsModule extends PageBaseModule {
    filter: Filter;

    constructor(module: DoctorsModule) {
        super(module);

        const page = new PageEntity();
        page.setModuleName(Doctors.moduleName);
        page.setTitle(Doctors.listTitle);
        page.setTitleAdd(Doctors.createTitle);
        page.setTitleEdit(Doctors.editTitle);
        page.values.actionPagination = 'doctors/updatePage';
        page.values.actionPageAmountItems = 'doctors/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Doctors.moduleName}_edit`;
        this.pageSettings.routeParam = `${Doctors.moduleName}Id`;

        const filter = new filterModel();
        this.filter = getModule(DoctorsFilter);
        this.filter.setFilterName('doctorsFilter');
        this.filter.setTemplateClassName('template-lg');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    processList(table: TableApiInterface) {
        table.rows.map(row => {
            if (row.phone) {
                row.phone = formatPhone(row.phone);
            }

            if (row.description) {
                row.description = truncateString(row.description);
            }

            row.hasActualSchedule = row.hasActualSchedule === true ? doctorDegreeEnum.YES : doctorDegreeEnum.NO;

            return row;
        });

        return table;
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(Doctors.apiPrefix,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter
            );
            const table = await this.processList(result.table);
            await this.context.dispatch('setList', table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(DoctorsModule);
